<template>
    <div class="home-container">
        <!-- 顶部统计卡片 -->
        <el-row :gutter="20" class="stat-cards">
            <el-col :lg="6" :sm="12" :xs="24">
                <div class="stat-card stat-card-blue">
                    <div class="stat-icon">
                        <i class="el-icon-school"></i>
                    </div>
                    <div class="stat-info">
                        <div class="stat-label">班级总数</div>
                        <div class="stat-value">{{ statistics.classCount || 0 }}</div>
                    </div>
                </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
                <div class="stat-card stat-card-green">
                    <div class="stat-icon">
                        <i class="el-icon-user-solid"></i>
                    </div>
                    <div class="stat-info">
                        <div class="stat-label">学生人数</div>
                        <div class="stat-value">{{ statistics.studentCount || 0 }}</div>
                    </div>
                </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
                <div class="stat-card stat-card-orange">
                    <div class="stat-icon">
                        <i class="el-icon-s-custom"></i>
                    </div>
                    <div class="stat-info">
                        <div class="stat-label">教师人数</div>
                        <div class="stat-value">{{ statistics.teacherCount || 0 }}</div>
                    </div>
                </div>
            </el-col>
            <el-col :lg="6" :sm="12" :xs="24">
                <div class="stat-card stat-card-purple">
                    <div class="stat-icon">
                        <i class="el-icon-document"></i>
                    </div>
                    <div class="stat-info">
                        <div class="stat-label">词汇总量</div>
                        <div class="stat-value">{{ statistics.wordCount || 0 }}</div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <!-- 课时不足预警 -->
        <el-card shadow="never" class="warning-card" v-if="warningList.length > 0">
            <div slot="header" class="warning-header">
                <div class="warning-title">
                    <i class="el-icon-warning warning-icon"></i>
                    <span>课时不足预警</span>
                    <el-tag type="danger" size="small" effect="dark" class="warning-badge">{{ warningTotal }} 名学生课时不足</el-tag>
                </div>
            </div>
            <el-table :data="warningList" stripe size="small" max-height="300">
                <el-table-column type="index" label="序号" width="60" />
                <el-table-column label="姓名" min-width="100" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-link type="warning" :underline="false" @click="gotoStudentList(row.nickname)">{{ row.nickname }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="username" label="账号" min-width="100" show-overflow-tooltip />
                <el-table-column prop="gradeName" label="年级" width="100" />
                <el-table-column prop="className" label="班级" width="120" show-overflow-tooltip />
                <el-table-column prop="classHours" label="剩余课时" width="100" align="center">
                    <template slot-scope="{row}">
                        <el-tag :type="row.classHours <= 0 ? 'danger' : 'warning'" size="small" effect="dark">
                            {{ row.classHours }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" width="130" show-overflow-tooltip />
            </el-table>
            <div class="warning-pagination" v-if="warningTotal > warningPageSize">
                <el-pagination
                    background
                    small
                    layout="total, prev, pager, next"
                    :total="warningTotal"
                    :page-size="warningPageSize"
                    :current-page.sync="warningCurrentPage"
                    @current-change="loadWarning"
                />
            </div>
        </el-card>

        <!-- 图表区第一行：词汇掌握概览 + 学生类型分布 -->
        <el-row :gutter="20" class="chart-row">
            <el-col :lg="12" :sm="24" :xs="24">
                <el-card shadow="never" class="chart-card">
                    <div slot="header" class="chart-header">
                        <span>词汇掌握概览</span>
                        <span v-if="statistics.wordMasteryOverview" class="mastery-rate">
                            掌握率 {{ statistics.wordMasteryOverview.masteryRate }}%
                        </span>
                    </div>
                    <div id="masteryChart" class="chart-box"></div>
                </el-card>
            </el-col>
            <el-col :lg="12" :sm="24" :xs="24">
                <el-card shadow="never" class="chart-card">
                    <div slot="header" class="chart-header">
                        <span>学生类型分布</span>
                    </div>
                    <div id="studentTypeChart" class="chart-box"></div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 图表区第二行：试卷生成趋势 -->
        <el-row :gutter="20" class="chart-row">
            <el-col :span="24">
                <el-card shadow="never" class="chart-card">
                    <div slot="header" class="chart-header">
                        <span>最近7天试卷生成趋势</span>
                    </div>
                    <div id="examTrendChart" style="width:100%;height:350px;"></div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 图表区第三行：年级分册词汇统计 + 测评卷概况 -->
        <el-row :gutter="20" class="chart-row">
            <el-col :lg="12" :sm="24" :xs="24">
                <el-card shadow="never" class="chart-card">
                    <div slot="header" class="chart-header">
                        <span>各年级词汇覆盖统计</span>
                    </div>
                    <div id="gradeWordChart" class="chart-box"></div>
                </el-card>
            </el-col>
            <el-col :lg="12" :sm="24" :xs="24">
                <el-card shadow="never" class="chart-card">
                    <div slot="header" class="chart-header">
                        <span>测评卷概况</span>
                    </div>
                    <div class="exam-overview">
                        <div class="exam-item">
                            <span class="exam-num">{{ statistics.examPaperCount || 0 }}</span>
                            <span class="exam-label">试卷总数</span>
                        </div>
                        <div class="exam-divider"></div>
                        <div class="exam-item">
                            <span class="exam-num complete">{{ statistics.completedExamPaperCount || 0 }}</span>
                            <span class="exam-label">已完成</span>
                        </div>
                        <div class="exam-divider"></div>
                        <div class="exam-item">
                            <span class="exam-num pending">{{ (statistics.examPaperCount || 0) - (statistics.completedExamPaperCount || 0) }}</span>
                            <span class="exam-label">进行中/待处理</span>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { reqEducationStatistics } from '@/api/education/statistics'
import { reqLowClassHours } from '@/api/system/users'

export default {
    name: 'Home',

    data() {
        return {
            loading: false,
            statistics: {},
            masteryChart: null,
            studentTypeChart: null,
            examTrendChart: null,
            gradeWordChart: null,
            // 课时预警
            warningList: [],
            warningTotal: 0,
            warningCurrentPage: 1,
            warningPageSize: 10
        }
    },

    created() {
        this.loadStatistics()
        this.loadWarning()
    },

    beforeDestroy() {
        this.disposeCharts()
    },

    methods: {
        async loadStatistics() {
            this.loading = true
            try {
                const data = await reqEducationStatistics()
                if (data) {
                    this.statistics = data
                    this.$nextTick(() => {
                        this.initCharts()
                    })
                }
            } catch (e) {
                console.error('获取统计数据失败', e)
            } finally {
                this.loading = false
            }
        },

        initCharts() {
            this.disposeCharts()
            this.drawMasteryChart()
            this.drawStudentTypeChart()
            this.drawExamTrendChart()
            this.drawGradeWordChart()
            this.bindResize()
        },

        // 词汇掌握概览 - 环形图
        drawMasteryChart() {
            const dom = document.getElementById('masteryChart')
            if (!dom) return
            this.masteryChart = echarts.init(dom)
            const overview = this.statistics.wordMasteryOverview || {}

            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c} ({d}%)'
                },
                legend: {
                    bottom: '0%',
                    textStyle: { fontSize: 12 }
                },
                series: [{
                    name: '单词掌握',
                    type: 'pie',
                    radius: ['50%', '72%'],
                    center: ['50%', '45%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 4,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: true,
                        position: 'outside',
                        formatter: '{b}\n{c}个'
                    },
                    data: [
                        { value: overview.proficientCount || 0, name: '熟练掌握', itemStyle: { color: '#67C23A' } },
                        { value: overview.masteredCount || 0, name: '已掌握', itemStyle: { color: '#409EFF' } },
                        { value: overview.unmasteredCount || 0, name: '未掌握', itemStyle: { color: '#E6A23C' } },
                        { value: overview.unlearnedCount || 0, name: '未学习', itemStyle: { color: '#F56C6C' } }
                    ]
                }]
            }
            this.masteryChart.setOption(option)
        },

        // 学生类型分布 - 饼图
        drawStudentTypeChart() {
            const dom = document.getElementById('studentTypeChart')
            if (!dom) return
            this.studentTypeChart = echarts.init(dom)
            const dist = this.statistics.studentTypeDistribution || {}

            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}人 ({d}%)'
                },
                legend: {
                    bottom: '0%',
                    textStyle: { fontSize: 12 }
                },
                series: [{
                    name: '学生类型',
                    type: 'pie',
                    radius: ['50%', '72%'],
                    center: ['50%', '45%'],
                    roseType: 'radius',
                    itemStyle: {
                        borderRadius: 6,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: true,
                        formatter: '{b}\n{c}人'
                    },
                    data: [
                        { value: dist.formalCount || 0, name: '正式学员', itemStyle: { color: '#409EFF' } },
                        { value: dist.trialCount || 0, name: '试学学员', itemStyle: { color: '#F56C6C' } }
                    ]
                }]
            }
            this.studentTypeChart.setOption(option)
        },

        // 最近7天试卷趋势 - 折线图
        drawExamTrendChart() {
            const dom = document.getElementById('examTrendChart')
            if (!dom) return
            this.examTrendChart = echarts.init(dom)
            const data = this.statistics.recentExamPapers || []

            const dates = data.map(d => d.date)
            const counts = data.map(d => d.count)

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'cross' }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: dates
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    name: '试卷数量'
                },
                series: [{
                    name: '生成试卷',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 8,
                    data: counts,
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: 'rgba(64, 158, 255, 0.35)' },
                            { offset: 1, color: 'rgba(64, 158, 255, 0.05)' }
                        ])
                    },
                    itemStyle: { color: '#409EFF' },
                    lineStyle: { width: 3 }
                }]
            }
            this.examTrendChart.setOption(option)
        },

        // 各年级词汇覆盖 - 柱状图（动态分册）
        drawGradeWordChart() {
            const dom = document.getElementById('gradeWordChart')
            if (!dom) return
            this.gradeWordChart = echarts.init(dom)
            const gradeStats = this.statistics.gradeVolumeStats || []

            // 收集所有年级名称和所有分册名称（保持顺序）
            const grades = []
            const volumeNamesSet = new Set()
            gradeStats.forEach(g => {
                grades.push(g.gradeName)
                ;(g.volumes || []).forEach(v => volumeNamesSet.add(v.volume))
            })
            const volumeNames = Array.from(volumeNamesSet)

            // 配色方案
            const colors = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#906EFF', '#1ABC9C']
            // 构建 series：每个分册一个柱状系列
            const series = volumeNames.map((volName, idx) => {
                const data = gradeStats.map(g => {
                    const v = (g.volumes || []).find(vv => vv.volume === volName)
                    return v ? v.wordCount : 0
                })
                return {
                    name: volName,
                    type: 'bar',
                    data,
                    itemStyle: { color: colors[idx % colors.length], borderRadius: [4, 4, 0, 0] },
                    barMaxWidth: 35
                }
            })

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                legend: {
                    data: volumeNames,
                    textStyle: { fontSize: 12 }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: grades
                },
                yAxis: {
                    type: 'value',
                    name: '单词数'
                },
                series
            }
            this.gradeWordChart.setOption(option)
        },

        disposeCharts() {
            if (this.masteryChart) { this.masteryChart.dispose(); this.masteryChart = null }
            if (this.studentTypeChart) { this.studentTypeChart.dispose(); this.studentTypeChart = null }
            if (this.examTrendChart) { this.examTrendChart.dispose(); this.examTrendChart = null }
            if (this.gradeWordChart) { this.gradeWordChart.dispose(); this.gradeWordChart = null }
        },

        bindResize() {
            const that = this
            window.addEventListener('resize', function () {
                if (that.masteryChart) that.masteryChart.resize()
                if (that.studentTypeChart) that.studentTypeChart.resize()
                if (that.examTrendChart) that.examTrendChart.resize()
                if (that.gradeWordChart) that.gradeWordChart.resize()
            })
        },

        gotoRoute(path) {
            this.$router.push(path)
        },

        gotoStudentList(nickname) {
            this.$router.push({
                path: '/education/personnel/student',
                query: { nickname }
            })
        },

        async loadWarning() {
            try {
                const data = await reqLowClassHours({
                    threshold: 5,
                    currentPage: this.warningCurrentPage,
                    pageSize: this.warningPageSize
                })
                this.warningList = data.records || []
                this.warningTotal = data.total || 0
            } catch (e) {
                console.error('获取课时预警数据失败', e)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.home-container {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 84px);

    .stat-cards {
        margin-bottom: 20px;
    }

    .stat-card {
        display: flex;
        align-items: center;
        padding: 24px 20px;
        border-radius: 8px;
        color: #fff;
        cursor: pointer;
        transition: transform .25s ease, box-shadow .25s ease;
        margin-bottom: 10px;

        &:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }

        .stat-icon {
            width: 60px;
            height: 60px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.2);
            margin-right: 18px;
            font-size: 28px;
        }

        .stat-info {
            .stat-label {
                font-size: 14px;
                opacity: 0.9;
                margin-bottom: 6px;
            }
            .stat-value {
                font-size: 30px;
                font-weight: 700;
                letter-spacing: 1px;
            }
        }

        &.stat-card-blue { background: linear-gradient(135deg, #409EFF, #337ECC); }
        &.stat-card-green { background: linear-gradient(135deg, #67C23A, #529B2E); }
        &.stat-card-orange { background: linear-gradient(135deg, #E6A23C, #CF9236); }
        &.stat-card-purple { background: linear-gradient(135deg, #906EFF, #7B5CE7); }
    }

    .warning-card {
        margin-bottom: 20px;
        border-radius: 8px;
        overflow: hidden;
        border-left: 4px solid #E6A23C;

        .warning-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .warning-title {
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 16px;
                font-weight: 600;
                color: #303133;

                .warning-icon {
                    font-size: 20px;
                    color: #E6A23C;
                }

                .warning-badge {
                    margin-left: 10px;
                }
            }
        }

        .warning-pagination {
            margin-top: 12px;
            text-align: right;
        }
    }

    .chart-row {
        margin-bottom: 20px;
    }

    .chart-card {
        border-radius: 8px;
        overflow: hidden;

        .chart-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            color: #303133;

            .mastery-rate {
                font-size: 14px;
                color: #409EFF;
                font-weight: 600;
            }
        }

        .chart-box {
            width: 100%;
            height: 320px;
        }
    }

    .exam-overview {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 40px 20px;

        .exam-item {
            text-align: center;

            .exam-num {
                display: block;
                font-size: 36px;
                font-weight: 700;
                color: #409EFF;

                &.complete { color: #67C23A; }
                &.pending { color: #E6A23C; }
            }

            .exam-label {
                font-size: 14px;
                color: #909399;
                margin-top: 8px;
                display: block;
            }
        }

        .exam-divider {
            width: 1px;
            height: 60px;
            background: #EBEEF5;
        }
    }
}
</style>
